import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {
  StationAvailabilities,
  StationDetail,
  StationPrice
} from 'src/app/models/api_models/station';
import {
  StationService
} from 'src/app/api/station.service';
import {
  ApiDate
} from 'src/app/models/api_models/apiDate';

@Component({
  selector: 'app-station-book-detail',
  templateUrl: './station-book-detail.component.html',
  styleUrls: ['./station-book-detail.component.scss']
})
export class StationBookDetailComponent implements OnInit {
  @Input() type : string = "autopartage";

  private _error: boolean = false;
  get error(): boolean {
    return this._error;
  }
  set error(error: boolean) {
    this._isLoad = error;
  }

  private _isLoad: boolean = false;
  get isLoad(): boolean {
    return this._isLoad;
  }
  set isLoad(isLoad: boolean) {
    this._isLoad = isLoad;
  }

  private _availabilities: string[] = [];
  get availabilities(): string[] {
    return this._availabilities
  };
  set availabilities(availabilities: string[]) {
    this._availabilities = availabilities;
  }

  private _stationDetail: StationDetail = undefined;
  get stationDetail(): StationDetail {
    return this._stationDetail;
  }
  set stationDetail(stationDetail: StationDetail) {
    // console.log(stationDetail);
    
    if (stationDetail != null && stationDetail.street != null )
    {
      this._stationDetail = stationDetail;
    }
    else {
      this.error = true;
    }

  }

  private _stationPrice: StationPrice = undefined;
  get stationPrice(): StationPrice {
    return this._stationPrice;
  }
  set stationPrice(stationPrice: StationPrice) {
    if (stationPrice != null && stationPrice.price != null )
    {
      this._stationPrice = stationPrice;
    }
    else {
      this.error = true;
    }
  }

  private _dayCount: Date[] = [];
  get dayCount(): Date[] {
    return this._dayCount;
  }
  set dayCount(dayCount: Date[]) {
    this._dayCount = dayCount;
  }

  private _hourCount: string[] = [];
  get hourCount(): string[] {
    return this._hourCount;
  }
  set hourCount(hourCount: string[]) {
    this._hourCount = hourCount;
  }



  private _canReserved = true;
  get canReserved(): boolean {
    return this._canReserved;
  }
  set canReserved(canReserved: boolean) {
    this._canReserved = canReserved;
  }

  private _departureDate: ApiDate;
  get departureDate() {
    return this._departureDate;
  }
  @Input()
  set departureDate(derpartureDate) {
    this._departureDate = derpartureDate;
  }

  private _arrivalDate: ApiDate;
  get arrivalDate() {
    return this._arrivalDate;
  }
  @Input()
  set arrivalDate(arrivalDate) {
    this._arrivalDate = arrivalDate;
  }

  private _stationAvailabilities: StationAvailabilities;
  get stationAvailabilities() {
    return this._stationAvailabilities;
  }
  @Input()
  set stationAvailabilities(stationAvailabilities :StationAvailabilities) {
    this._stationAvailabilities = stationAvailabilities;
    // console.error(stationAvailabilities);

    if (this._stationAvailabilities != null) {
      this.stationService.getStationDetailFromId(this._stationAvailabilities.id).subscribe(
        response => {
          if (response == null) {
            this._error = true;
          }
          this._stationDetail = response;
          // console.log(this._stationDetail);
          
        }
      );

    }
  }

  @Output() stationSelect = new EventEmitter();
  public stationSelected() {
    this.stationSelect.emit(this._stationDetail.id);
  }


  getResaDuration() {
    // todo  probleme de date   a revoir quand l api sera prete
    let duration = (this._arrivalDate.date.getTime() ) - (this._departureDate.date.getTime() );
    duration = ((duration / 1000) / 60) / 30;
    // console.log(duration);
    return duration;
  }

  convertAvalabilites() {
    let tab = [];
    let startDate = new Date(this.departureDate.getDateToApiFormat());
    startDate.setHours(0, 0, 0, 0);
    let day_start = startDate.getDay();
    this._dayCount.push(new Date(startDate));
    let endDate = new Date(this.arrivalDate.getDateToApiFormat());
    endDate.setHours(23, 59, 0, 0);
    let isWanted = false;
    while (startDate < endDate) {
      isWanted = false;
      let strClass = "  ";
      if (startDate.getMinutes() == 0) {
        if (startDate.getHours() % 2 == 0) {
          if (startDate.getHours() < 10) {
            this._hourCount.push("0" + startDate.getHours() + "h");
          } else {
            this._hourCount.push(startDate.getHours() + "h");
          }
        } else {
          this._hourCount.push("    ");
        }
      }

      if (day_start != startDate.getDay()) {
        day_start = startDate.getDay();
        this._dayCount.push(new Date(startDate));
      }

      if (startDate.getTime() == this._departureDate.date.getTime()) {
        strClass += " start ";
      }
      if (startDate.getTime() >= this._departureDate.date.getTime() && (startDate.getTime() + (1000 * 60 * 30)) <= this._arrivalDate.date.getTime()) {
        strClass += " wanted ";
        isWanted = true;
      }
      if ((startDate.getTime() + (1000 * 60 * 30)) == this._arrivalDate.date.getTime()) {
        strClass += "end";
      }

      let isStart = false;
      let isEnd = false;
      let isLock = true;
      this._stationAvailabilities.availabilities.forEach(a => {

        let dStart = new Date(a.startdate.replace("Z", ""));
        let dEnd = new Date(a.enddate.replace("Z", ""));


        if (startDate.getTime() == (dStart.getTime() - (1000 * 60 * 30))) {
          strClass += " end ";
          if (isWanted) {
            this._canReserved = false;
          }
          strClass += " reserved ";


        }
        if (startDate.getTime() >= (dStart.getTime() - (1000 * 60 * 30)) && startDate.getTime() <= dEnd.getTime()) {
          isLock = false;
        }
        if (startDate.getTime() == dEnd.getTime()) {
          strClass += " start ";
          if (isWanted) {
            this._canReserved = false;
          }
          strClass += " reserved ";
        }
      });
      if (isLock) {
        if (isWanted) {
          this._canReserved = false;
        }

        strClass += " reserved ";
      }

      tab.push(strClass);
      startDate.setTime(startDate.getTime() + 1000 * 60 * 30);
    }
    return tab;
  }

  
  constructor(private stationService: StationService) {}

  ngOnInit() {

    // todo  probleme de date   a revoir quand l api sera prete 
    let correctiondepart : any = new Date(this._departureDate.date.getTime())

    this.stationService.stationGetPrice(this._stationAvailabilities.id, this.getResaDuration(), correctiondepart).subscribe(
      response => {
        if (response == null) {
            this._error = true;
        }
        else {
          this._stationPrice = response;
          // console.log(this._stationPrice);
          
          this._availabilities = this.convertAvalabilites();
          this._isLoad = true;

        }
      },
      error => {
        this.error = true;
        this._isLoad = false;
      }
    );
  }

}
